<script>
import Alert from '@/components/Alert';

export default {
  components: {
    Alert
  }
}
</script>

<template>
  <Alert v-html="__('cancel_requested_text')"/>
</template>